class EventDispather {
    log(){

    }
    addEventListener(type, handler) {
        //addEventListener(type,handler,handlerThis,this);
        if (typeof type == "undefined") {
            this.log(type);
            throw new Error("type is undefined");
        }
        if (typeof handler == "undefined") {
            this.log(handler);
            throw new Error("handler is undefined");
        }
        var _this = this;
        if (!_this.hasOwnProperty("EventMap")) {
            _this.EventMap = {};
        }
        if (_this.EventMap.hasOwnProperty(type)) {
        } else {
            _this.EventMap[type] = [];
        }
        if (!_this.hasEventListener(type, handler)) {
            _this.EventMap[type].push({fun: handler});
        }
    }

    hasEventListener(type, handler) {
        if (typeof type == "undefined") {
            this.log(type);
            throw new Error("type is undefined");
        }
        if (typeof handler == "undefined") {
            this.log(handler);
            throw new Error("handler is undefined");
        }
        var _this = this;
        if (_this.hasOwnProperty("EventMap") && _this.EventMap.hasOwnProperty(type)) {
            for (var i = 0; i < _this.EventMap[type].length; i++) {
                var item = _this.EventMap[type][i];
                if (item.fun == handler) {
                    return true;
                }
            }
        }
        return false;
    }
    dispatchEvent(type,data) {
        var _this = this;
        if (!_this.hasOwnProperty("EventMap")) {
            _this.EventMap = {};
        }
        if (_this.EventMap.hasOwnProperty(type)) {
            var disPatchArr = [];
            for (var i = 0; i < _this.EventMap[type].length; i++) {
                disPatchArr.push(_this.EventMap[type][i]);
            }
            for (var i = 0; i < disPatchArr.length; i++) {
                disPatchArr[i].fun(data);
            }
        }
    }
    removeAllEventListener(type) {
        var _this = this;
        if (!_this.hasOwnProperty("EventMap")) {
            _this.EventMap = {};
        }
        if (_this.EventMap.hasOwnProperty(type)) {
            delete _this.EventMap[type];
        }
        // removeEventListener(type,handler,handlerThis,this);
    }
    removeEventListener(type, handler) {
        var _this = this;
        if (!_this.hasOwnProperty("EventMap")) {
            _this.EventMap = {};
        }
        if (_this.EventMap.hasOwnProperty(type)) {
            for (var i = 0; i < _this.EventMap[type].length; i++) {
                if (_this.EventMap[type][i].fun == handler) {
                    _this.EventMap[type].splice(i, 1);
                    if (_this.EventMap[type].length == 0) {
                        delete  _this.EventMap[type]
                    }
                    break;
                }
            }
        }
    }
    destroy() {
        for (var key in this.EventMap) {
            delete this.EventMap[key];
        }
        this.EventMap = null;
    }
}
export default EventDispather